import * as React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SortAscendSvg from './sort-ascend.svg';
import SortDescendSvg from './sort-descend.svg';

type Props = {
    ascending?: boolean;
};

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;
    delete validProps.ascending;

    if (props.ascending === true) {
        // @ts-expect-error
        return <SortAscendSvg {...validProps} />;
    }

    // @ts-expect-error
    return <SortDescendSvg {...validProps} />;
}
SvgComponent.iconName = 'sort';

export const SortIcon = svgIconWrapper(SvgComponent);
